module.exports = __webpack_public_path__ + "img/Vehicle-1.4cb68bb4.png";